var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eth",
    clipPath: "url(#clip0_2_18585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.25 2V6.435L11.9985 8.11L8.25 2Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.249 2L4.5 8.11L8.249 6.435V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.25 10.9841V13.9976L12.001 8.80811L8.25 10.9841Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.249 13.9976V10.9836L4.5 8.80811L8.249 13.9976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.25 10.2865L11.9985 8.11003L8.25 6.43604V10.2865Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.5 8.11003L8.249 10.2865V6.43604L4.5 8.11003Z",
    fill: "white",
    fillOpacity: 0.602
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_18585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.2df4a9f757dda6b0ec22b5c96098804c.svg";
export { ForwardRef as ReactComponent };